<template>
  <el-dialog
    title="检测低销量商品"
    :visible.sync="internalVisible"
    width="820px"
    class="low-sales-dialog"
  >
    <div class="low-sales-content">
      <div class="settings">
        <div class="title">检测范围设置 <span class="sub">同时满足以下条件判定为低销量商品</span></div>
        <div class="row">
          <div class="label">创建时间超过：</div>
          <el-select v-model="createDays" placeholder="请选择" style="width: 240px">
            <el-option v-for="opt in dayOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
        </div>
        <div class="row">
          <div class="label">销量情况：</div>
          <div class="inline">
            <el-select v-model="salesDays" placeholder="请选择" style="width: 180px">
              <el-option v-for="opt in dayOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
            </el-select>
            <span class="tip">内销量小于等于</span>
            <el-input-number v-model="salesThreshold" :min="0" :step="1" style="width: 120px" />
          </div>
        </div>
        <div class="desc">
          单量统计口径：<br />
          已关联规格维度的 ERP 商品，以发货时间为基准，统计时间段内已发货订单关联该商品的数量，不扣减退款数量；款维度根据规格维度汇总。<br />
          未关联 ERP 商品的快麦通商品视为销量为 0。
        </div>
        <div class="actions">
          <el-button type="primary" @click="onScan">扫描商品</el-button>
        </div>
      </div>
      <div class="result">
        <div class="title">检测结果</div>
        <div class="metric">
          <div class="label">
            预计低销量商品
            <i class="el-icon-question" />
          </div>
          <div class="value">{{ resultCount }}</div>
        </div>
        <div class="actions">
          <el-button @click="$emit('view')">查看商品</el-button>
          <el-button type="danger" @click="$emit('delete')">删除商品</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'LowSalesDialog',
  props: {
    visible: { type: Boolean, default: false },
    resultCount: { type: Number, default: 0 },
  },
  data() {
    return {
      internalVisible: this.visible,
      dayOptions: [
        { label: '30天内', value: 30 },
        { label: '60天内', value: 60 },
        { label: '90天内', value: 90 },
        { label: '180天内', value: 180 },
        { label: '1年内（365天）', value: 365 },
      ],
      createDays: 180,
      salesDays: 180,
      salesThreshold: 0,
    };
  },
  watch: {
    visible(val) { this.internalVisible = val; },
    internalVisible(val) { this.$emit('update:visible', val); },
  },
  methods: {
    onScan() {
      const payload = {
        createDays: this.createDays,
        salesDays: this.salesDays,
        salesThreshold: this.salesThreshold,
      };
      this.$emit('scan', payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.low-sales-content {
  display: flex;
  align-items: stretch;
}
.settings {
  flex: 1;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 16px;
  background: #fff;
}
.settings .title {
  font-weight: 600;
  margin-bottom: 16px;
}
.settings .sub { color: #999; font-weight: 400; margin-left: 8px; }
.row { display: flex; align-items: center; margin-bottom: 16px; flex-wrap: nowrap; }
.row .label { width: 110px; color: #666; }
.row .inline { display: flex; align-items: center; flex-wrap: nowrap; white-space: nowrap; }
.row .tip { margin: 0 8px; color: #666; }
.desc { color: #999; font-size: 12px; line-height: 1.6; margin-top: 8px; }
.settings .actions { margin-top: 16px; display: flex; justify-content: center; }

.result {
  width: 280px;
  margin-left: 16px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 16px;
  background: #fff;
}
.result .title { font-weight: 600; margin-bottom: 8px; }
.metric .label { color: #666; display: flex; align-items: center; }
.metric .label i { margin-left: 4px; color: #999; }
.metric .value { font-size: 40px; font-weight: 700; margin: 20px 0; text-align: center; }
.result .actions .el-button + .el-button { margin-left: 12px; }
/* 按钮纵向排列并居中 */
.result .actions {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.result .actions .el-button + .el-button {
  margin-left: 0;
  margin-top: 12px;
}
</style>